import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroImage } from '../data/content';
export function Hero() {
  return <header className="relative w-full bg-cream" data-id="element-38" data-mp="ei1wlphg28zj">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 pb-16 pt-16 sm:pt-20 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:pb-28 lg:pt-24" data-id="element-39" data-mp="9lv1krql6hwd">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="order-2 lg:order-1" data-id="element-40" data-mp="129h37ug97cgl">
          <p className="font-sans text-xs uppercase tracking-[0.28em] text-gold-deep" data-id="element-41" data-mp="sb1chsl5257m">
            Guía digital · Desde el miedo hacia la libertad
          </p>

          <h1 className="mt-6 font-serif text-4xl leading-[1.08] text-ink sm:text-5xl lg:text-6xl" data-id="element-42" data-mp="nbyir4alzley">
            Deja de dejar que el miedo{' '}
            <em className="not-italic text-gold-deep" data-id="element-43" data-mp="381xn73sg3cct">decida por ti</em>
          </h1>

          <p className="mt-6 max-w-md font-sans text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-44" data-mp="3j8sd1u7lx7mo">
            Una guía que une psicología y espiritualidad para sanar tu relación
            con el miedo. Sin fórmulas mágicas. Con pasos que puedes dar hoy.
          </p>

          <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-45" data-mp="39cfkiznsszti">
            <CtaButton href="#precio" data-id="element-46" data-mp="3ebisosz2rm5p">Quiero mi guía ahora</CtaButton>
            <span className="font-sans text-sm text-ink-light" data-id="element-47" data-mp="30h9bzsx583na">
              PDF · Acceso inmediato
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.9,
        ease: 'easeOut',
        delay: 0.1
      }} className="order-1 lg:order-2" data-id="element-48" data-mp="2qk3lalsfyenl">
          <div className="relative overflow-hidden rounded-[2rem] bg-sand" data-id="element-49" data-mp="2hk85g3nxxvh8">
            <img src={heroImage} alt="Silueta de una persona de pie frente a una puerta atravesada por luz dorada" className="h-[320px] w-full object-cover sm:h-[440px] lg:h-[560px]" data-id="element-50" data-mp="2lla4okhuy7j7" />
          </div>
        </motion.div>
      </div>
    </header>;
}